import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useSubscription } from '@/hooks/useSubscription';
import type { Tier } from '@/data/tiers';

interface TierCardProps {
  tier: Tier;
}

export default function TierCard({ tier }: TierCardProps) {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const { subscription, isActive } = useSubscription();
  const onCurrentTier = isActive && subscription?.tier === tier.id;

  function handleClick() {
    if (authLoading) return;
    if (!user) {
      navigate(`/signin?from=${encodeURIComponent(`/subscribe?tier=${tier.id}`)}`, {
        state: { from: `/subscribe?tier=${tier.id}` },
      });
      return;
    }
    if (onCurrentTier) {
      navigate('/account');
      return;
    }
    navigate(`/subscribe?tier=${tier.id}`);
  }

  const label = onCurrentTier ? 'Current plan' : isActive ? 'Switch plan' : 'Subscribe →';

  return (
    <div className={`tier${tier.featured ? ' featured' : ''}`}>
      {tier.featured && <div className="tier-badge">Most Popular</div>}
      <div className="tier-name">{tier.name}</div>
      <div className="tier-price">
        ${tier.price}
        <span className="tier-price-suffix">/mo</span>
      </div>
      <div className="tier-period">{tier.period}</div>
      <ul className="tier-features">
        {tier.features.map((f, i) => (
          <li key={i} className={f.dim ? 'dim' : ''}>
            {f.text}
          </li>
        ))}
      </ul>
      <button
        type="button"
        className={`btn block${tier.featured ? '' : ' dark'}`}
        onClick={handleClick}
        disabled={authLoading}
      >
        {label}
      </button>
    </div>
  );
}
